import { RadioGroup } from '@platform/components';
import { UpdateDiscoveryCallFormData, UpdateType } from '.';
import { Users } from '@platform/client';
import { FormState, UseFormRegister, UseFormSetValue } from 'react-hook-form';

type UpdateSelectionContentProps = {
  register: UseFormRegister<UpdateDiscoveryCallFormData>;
  setValue: UseFormSetValue<UpdateDiscoveryCallFormData>;
  selectedUpdateType: UpdateType | undefined | null;
  formState: FormState<UpdateDiscoveryCallFormData>;
};

export const UpdateSelectionContent = (props: UpdateSelectionContentProps) => {
  const user = Users.useGetCurrentUser();

  const updateSelectionItems = [
    {
      value: UpdateType.Completed,
      title: 'Completed',
    },
    {
      value: UpdateType.Unresponsive,
      title: `This ${user.data?.accountType == 'experteer' ? 'organization' : 'Experteer'} is unresponsive`,
    },
    {
      value: UpdateType.Other,
      title: 'I have a different update',
    },
  ];

  return (
    <div className='flex flex-col gap-8 items-center md:mt-8 md:w-[500px]'>
      <div className='text-center text-xl'>What's the status of your Discovery Call?</div>
      <div className='mt-4 w-full'>
        <RadioGroup
          name='update-selection'
          aria-label='update-selection'
          items={updateSelectionItems}
          register={() =>
            props.register('updateType', { required: 'Select one option to continue' })
          }
          onChange={(value) => {
            props.setValue('updateType', value as UpdateType, { shouldValidate: true });
          }}
          defaultValue={props.selectedUpdateType ?? undefined}
          error={props.formState.errors.updateType?.message}
        />
      </div>
    </div>
  );
};
